import _ from 'lodash'

import {
  updateUserApiKey,
  registerUser,
  getRoles,
  getProjects,
  getUserByLoginId,
  getUserDetail,
  registerMembership,
  getCustomFields
} from 'src/services/redmine'

export const getRedmineUser = user => {
  return new Promise((resolve, reject) => {
    let { userLoginId, firstName, lastName, emailAddress } = user
    getUserByLoginId(userLoginId).then(({ id }) => {
      getUserDetail(id).then(redmineUser => {
        resolve(redmineUser)
      }).catch(({ message }) => {
        reject({ message })
      })
    }).catch(({ message }) => {
      registerUser({
        user: {
          login: userLoginId,
          firstname: firstName,
          lastname: lastName,
          mail: emailAddress,
          password: '12345678'
        }
      }).then(({ id }) => {
        getUserDetail(id).then(redmineUser => {
          resolve(redmineUser)
        }).catch(({ message }) => {
          reject({ message })
        })
      }).catch(({ message }) => {
        reject({ message })
      })
    })
  })
}

export const getProject = () => {
  return new Promise((resolve, reject) => {
    getProjects().then(projects => {
      let mst = projects.find(project => project.identifier === 'wip-mst')
      if (mst) {
        resolve(mst)
      } else {
        reject({ message: 'MST does not exist in Redmine.' })
      }
    }).catch(({ message }) => {
      reject({ message })
    })
  })
}

export const registerMembershipIfNeeded = ({ redmineUser, project, roleName }) => {
  return new Promise((resolve, reject) => {
    if (redmineUser.memberships.find(membership => membership.project.id === project.id)) {
      resolve(redmineUser)
    } else {
      getRoles().then(roles => {
        let role = roles.find(role => role.name === roleName)
        registerMembership({
          project,
          redmineUser,
          role
        }).then(membership => {
          redmineUser.memberships.push(_.omit(membership, ['user']))
          resolve(redmineUser)
        }).catch(({ message }) => {
          reject({ message })
        })
      }).catch(({ message }) => {
        reject({ message })
      })
    }
  })
}

export const didUserLoginRedmine = (redmineUser) => {
  updateUserApiKey(redmineUser['api_key'])
}

export const getMasterData = () => {
  return new Promise((resolve, reject) => {
    Promise.all([
      getCustomFields()
    ]).then(masterDataSet => {
      let [
        customFields
      ] = [...masterDataSet]
      console.log(customFields)
    }).catch(({ message }) => {
      reject({ message })
    })
  })
}



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/service-request/service.js